import {
    type FC
} from "react";
import type IChartAxisProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    Text as SvgText,
    G
} from "react-native-svg";

export const CHART_AXIS_BASELINE_SHIFT = 0.35;

const ChartAxis: FC<IChartAxisProps> = ({
    tone = "value",
    isRTL = false,
    customTheme,
    orientation,
    ticks,
    plot
}) => {
    const {
        typography,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const textStyle = typography.bodySmallSize;

    const isHorizontal = orientation === "horizontal";

    const color = tone === "category" ? colors.content.text.mid : colors.content.text.low;

    const verticalX = isRTL ? plot.x + plot.width + spaces.spacingSm : plot.x - spaces.spacingSm;

    return <G
        aria-hidden={true}
    >
        {
            ticks.map((tick) => <SvgText
                y={isHorizontal ? plot.y + plot.height + spaces.spacingSm + textStyle.fontSize : tick.position + textStyle.fontSize * CHART_AXIS_BASELINE_SHIFT}
                textAnchor={isHorizontal ? "middle" : isRTL ? "start" : "end"}
                x={isHorizontal ? tick.position : verticalX}
                key={`${tick.position}-${tick.label}`}
                fontWeight={textStyle.fontWeight}
                fontFamily={textStyle.fontFamily}
                fontSize={textStyle.fontSize}
                fill={color}
            >
                {tick.label}
            </SvgText>)
        }
    </G>;
};
export default ChartAxis;
